import * as Yup from "yup";
import CarForm from "./formModel";
import {isValidPhoneNumber} from 'react-phone-number-input'

const {
    formField: {
        name,
        lastName,
        phone,
        email,
        postCode,
        dni,
        carProdSelected,
        vehiculo: {
            marca,
            anio,
            modelo,
            version,
            valorGnc,
            adtValue,
        }
    },
} = CarForm;

export default [
    Yup.object().shape({
        [name.name]: Yup.string()
            .required(`${name.requiredErrorMsg}`)
            .matches(/^[aA-zZ\u00f1\u00d1\s]+$/, "Ingrese un nombre válido")
            .max(40, "El nombre ingresado es muy largo"),
        [lastName.name]: Yup.string()
            .required(`${lastName.requiredErrorMsg}`)
            .matches(/^[aA-zZ\u00f1\u00d1\s]+$/, "Ingrese un apellido válido")
            .max(40, "El apellido ingresado es muy largo"),

        // [nacimiento.name]: Yup.date().required(`${nacimiento.requiredErrorMsg}`).test(
        //     "nacimiento",
        //     "Debe ser mayor de 18 años para utilizar Polko.",
        //     value => {
        //         return moment().diff(moment(value),'anios') >= 18;
        //     }
        // ),
        [email.name]: Yup.string()
            .required(`${email.requiredErrorMsg}`)
            .email("Ingrese un email válido"),
        [phone.name]: Yup.string()
            .test('telefono', "El celular ingresado no es válido",
                (value) => {
                    if (value && typeof value === "string")
                        return (isValidPhoneNumber(value))
                    else return false
                }
            ),
        [postCode.name]: Yup.string().required(`${postCode.requiredErrorMsg}`)
            .test('postCode', "Seleccione una localidad válida",
                (value) => {
                    if (value) return value.includes(",")
                    else return false
                }),
        [dni.name]: Yup.number()
            .required(`${dni.requiredErrorMsg}`)
            .min(1000000, "El documento ingresado no es válido")
            .max(99999999, "El documento ingresado no es válido")
            .integer()
            .typeError("Introduzca únicamente números"),

    }),
    Yup.object().shape({
        vehiculo: Yup.object().shape({
            marca: Yup.string()
                .required(`${marca.requiredErrorMsg}`)
                .matches(/^[A-Za-z0-9 ,-]+$/, "Esta utilizando carácteres no válidos"),
            modelo: Yup.string()
                .required(`${modelo.requiredErrorMsg}`)
                .matches(/^[A-Za-z0-9 ,-]+$/, "Esta utilizando carácteres no válidos"),
            version: Yup.string()
                .required(`${version.requiredErrorMsg}`)
                .matches(/^[A-Za-z0-9 ,-]+$/, "Esta utilizando carácteres no válidos"),
            patente: Yup.string()
                .matches(/^([a-zA-Z]{2,3})([0-9]{3})([a-zA-Z]{2})?$/, "La patente ingresada no es válida"),
            anio: Yup.number()
                .required(`${anio.requiredErrorMsg}`)
                .integer()
                .typeError("Introduzca únicamente números"),
            adtValue: Yup.number()
                .required(`${adtValue.requiredErrorMsg}`)
                .min(0, "El valor no puede ser negativo")
                .max(2000000, "El monto máximo es $2.000.000"),
            valorGnc: Yup.number()
                .required(`${valorGnc.requiredErrorMsg}`)
                .min(450000, "El monto mínimo es $450.000")
                .max(3000000, "El monto máximo es $2.000.000")
            // [ceroKm.name]: Yup.string().required(`${ceroKm.requiredErrorMsg}`),
            // [tieneGNC.name]: Yup.string().required(`${tieneGNC.requiredErrorMsg}`),
        })
    }),
    Yup.object().shape({
        [carProdSelected.name]: Yup.string().required(
            `${carProdSelected.requiredErrorMsg}`
        ),
    }),
];